import { __assign, __rest } from "tslib";
import { BrowserClient } from "@sentry/browser/esm/client";
import { initAndBind } from "@sentry/core/esm/sdk";
import { LinkedErrors } from "@sentry/browser/esm/integrations/linkederrors";
import { UserAgent } from "@sentry/browser/esm/integrations/useragent";
import { InboundFilters } from "@sentry/core/esm/integrations/inboundfilters";
import { FunctionToString } from "@sentry/core/esm/integrations/functiontostring";
import { GlobalHandlers } from "@sentry/browser/esm/integrations/globalhandlers";
import { Breadcrumbs } from "@sentry/browser/esm/integrations/breadcrumbs";
var integrations = [
    new InboundFilters(),
    new FunctionToString(),
    new GlobalHandlers({ onerror: false, onunhandledrejection: false }),
    new Breadcrumbs({
        console: true,
        dom: false,
        fetch: false,
        history: false,
        sentry: true,
        xhr: false
    }),
    new LinkedErrors(),
    new UserAgent(),
];
export function init(conf) {
    var sentryDsn = conf.sentryDsn, opts = __rest(conf, ["sentryDsn"]);
    initAndBind(BrowserClient, __assign({ dsn: sentryDsn, integrations: integrations }, opts));
}
export { captureException } from "@sentry/minimal";
//# sourceMappingURL=mini.js.map